<template>
  <Modal
    :is-open="isOpen"
    icon="envelope"
    title="Send Invite"
    :buttons="['close', 'ok']"
    :description="'Send an email invite to ' + customerName"
    close-text="Cancel"
    ok-text="Send"
    min-width="500"
    max-width="500"
    :has-unsaved-changes="hasUnsavedChanges"
    :is-confirming="isLoading"
    @close-modal="$emit('close')"
    @ok-modal="$emit('save')"
  >
    <Select
      :model-value="selectedTemplateID ?? undefined"
      :options="marketingTemplates"
      placeholder="Select a template..."
      value-key="id"
      label-key="name"
      on-select-return-as-object
      :has-error="hasError"
      @update:model-value="$emit('update:selected-template-id', $event)"
      @select="$emit('select-template', $event)"
    />
    <InputError :has-error="hasError">{{ errorMessage }}</InputError>

    <ListGroup
      v-if="selectedTemplateBody"
      class="my-4"
    >
      <ListGroupItem>
        <div class="flex gap-2">
          <div class="text-tertiary">Subject</div>
          {{ selectedTemplateSubject }}
        </div>
      </ListGroupItem>
      <Separator />
      <ListGroupItem>
        <div
          class="w-full overflow-auto pointer-events-none select-none"
          style="user-select: none; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none"
          v-html="selectedTemplateBody"
        ></div>
      </ListGroupItem>
    </ListGroup>
  </Modal>
</template>

<script setup lang="ts">
// components
import Modal from '@/components/modal/Modal.vue'
import Select from '@/components/forms/Select.vue'
import InputError from '@/components/forms/InputError.vue'
import ListGroup from '@/components/list/ListGroup.vue'
import ListGroupItem from '@/components/list/ListGroupItem.vue'
import Separator from '@/components/separator/Separator.vue'

interface MarketingTemplate {
  id: number
  name: string
  subject: string
  body: string
}

interface Props {
  isOpen: boolean
  isLoading: boolean
  hasUnsavedChanges: boolean
  customerName: string
  selectedTemplateID: number | null
  selectedTemplateSubject: string | null
  selectedTemplateBody: string | null
  marketingTemplates: MarketingTemplate[]
  hasError: boolean
  errorMessage: string | null
}

defineProps<Props>()

defineEmits<{
  close: []
  save: []
  'update:selected-template-id': [id: number | null]
  'select-template': [template: MarketingTemplate]
}>()
</script>
